import React from 'react';

interface CenteredHeaderProps {
  title: string;
  subtitle: string;
  className?: string;
}

const CenteredHeader: React.FC<CenteredHeaderProps> = ({
  title,
  subtitle,
  className = ''
}) => {
  return (
    <div className={`text-center mb-8 ${className}`}>
      {/*<div className="h-24 mx-auto mb-4 relative">*/}
      {/*  <div className="absolute inset-3 flex items-center justify-center">*/}
      {/*    <img src="images/logo.svg" alt="Logo" className="w-full h-full"/>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <h1 className="text-3xl font-cinzel font-bold text-gray-900 mb-2">{title}</h1>
      <p className="text-gray-600">{subtitle}</p>
    </div>
  );
};

export default CenteredHeader;
